import Noty from "noty";
import "noty/lib/noty.css";
import "noty/lib/themes/semanticui.css";
import { isNotEmpty } from "./strings";
import "../../style/common/noty/_noty_custom.scss";

let _theme = "semanticui";

/**
 * 確認ダイアログ表示
 */
export function popConfirm(message, callAccept = () => {}, callDecline = () => {}) {
  confirmMessage({
    message: message,
    callAccept: callAccept,
    callDecline: callDecline,
  });
}

/**
 * メッセージ表示
 */
export function popInfo(message, callClose = () => {}) {
  showMessages({
    message: message, type: "info",
    callClose: callClose,
  })
}

/**
 * エラー表示
 */
export function popErrors(message) {
  showMessages({message: message, type: "error"})
}


/**
 * 確認ダイアログ表示
 */
export function confirmMessage(
  {
    message,
    layout = "center",
    modal = true,
    type = "alert",
    callAccept = () => {},
    callDecline = () => {},
  }) {
  let n = new Noty({
    text: message,
    theme: _theme,
    modal: modal,
    type: type,
    layout: layout,
    closeWith: [],
    buttons: [
      Noty.button(
        "いいえ",
        "btn btn-light btn-sm",
        function () {
          callDecline();
          n.close();
        },
        { id: "btn-no", "data-status": "no" }
      ),
      Noty.button(
        "はい",
        "btn btn-primary btn-sm",
        function () {
          callAccept();
          n.close();
        },
        { id: "btn-yes", "data-status": "yes" }
      ),
    ],
  });
  n.show();
}

/**
 * メッセージ表示（改行をリスト表示）
 */
export function showMessages(
  {
    message,
    layout = "center",
    modal = true,
    type = "info",
    callClose = () => {}
  }) {
  let error_message;
  if(/\r\n|\r|\n/.test(message)) {
    error_message =
      "<ul>";
    let textArray = message.split(/\r\n|\r|\n/);
    textArray.forEach(function(value) {
      if (isNotEmpty(value)) {
        error_message = error_message + "<li>" + value + "</li>";
      }
    });
    error_message = error_message + "</ul>";
  } else {
    error_message = message;
  }
  let n = new Noty({
    text: error_message,
    theme: _theme,
    modal: modal,
    type: type,
    layout: layout,
    closeWith: [],
    buttons: [
      Noty.button(
        "閉じる",
        "btn btn-light btn-sm",
        function () {
          callClose();
          n.close();
        },
        { id: "button1", "data-status": "ok" }
      ),
    ],
  });
  n.show();
}